<template>
  <div v-if="user != ''" class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="subpage-head-image" style="background-image: url('assets/img/subpage-head.jpg');">
      <div class="container">
        <h1>
          {{ title.main }}
          <span>{{ title.sub }}</span>
        </h1>
      </div>
    </div>

    <div class="submenu clearfix">
      <div class="container">
        <ul class="submenu-ul">
          <li :class="{active: this.$route.params.page == 'osztondij'}">
            <a v-on:click="changePage('osztondij')" href="javascript:void(0)">Ösztöndíjak</a>
          </li>
          <li :class="{active: this.$route.params.page == 'szerv_jel'}">
            <a v-on:click="changePage('szerv_jel')" href="javascript:void(0)">Szervezeti jelentkezés</a>
          </li>
          <li :class="{active: this.$route.params.page == 'rendszeres_szocialis_osztondij'}">
            <a v-on:click="changePage('rendszeres_szocialis_osztondij')" href="javascript:void(0)">Rendszeres Szociális Ösztöndíj</a>
          </li>

          <!--
          <li :class="{active: this.$route.params.page == 'osztondijszerzodes' || this.$route.params.page == 'unkp_tanulmanykotet' || this.$route.params.page == 'unkp_beszamolo' || this.$route.params.page == 'unkp_beszamolo_10'}">
            <a href="javascript:void(0)" title="ÚNKP">ÚNKP-19</a>
            <ul>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_10_mod'}">
                <a v-on:click="changePage('unkp_beszamolo_10_mod')" href="javascript:void(0)">ÚNKP-19 10 havi módosított beadási határidejű<br>szakmai záró beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_10'}">
                <a v-on:click="changePage('unkp_beszamolo_10')" href="javascript:void(0)">ÚNKP-19 10 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo'}">
                <a v-on:click="changePage('unkp_beszamolo')" href="javascript:void(0)">ÚNKP-19 5 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_tanulmanykotet_19'}">
                <a v-on:click="changePage('unkp_tanulmanykotet_19')" href="javascript:void(0)">ÚNKP-19 Tanulmánykötet</a>
              </li>
              <li :class="{active: this.$route.params.page == 'osztondijszerzodes'}">
                <a v-on:click="changePage('osztondijszerzodes')" href="javascript:void(0)">ÚNKP-19 Ösztöndíjszerződés</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="javascript:void(0)" title="ÚNKP">ÚNKP-20</a>
            <ul>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_20_12'}">
                <a v-on:click="changePage('unkp_beszamolo_20_12')" href="javascript:void(0)">ÚNKP-20 12 havi szakmai záró beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_20_7'}">
                <a v-on:click="changePage('unkp_beszamolo_20_7')" href="javascript:void(0)">ÚNKP-20 7 havi szakmai záró beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_20_5'}">
                <a v-on:click="changePage('unkp_beszamolo_20_5')" href="javascript:void(0)">ÚNKP-20 5-6 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_tanulmanykotet_20'}">
                <a v-on:click="changePage('unkp_tanulmanykotet_20')" href="javascript:void(0)">ÚNKP-20 Tanulmánykötet</a>
              </li>
              <li>
                <a v-on:click="konzultaciosLap(20)" href="javascript:void(0)">Konzultációs lap letöltése</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_konferencia'}">
                <a v-on:click="changePage('unkp_konferencia')" href="javascript:void(0)">ÚNKP Konferencia</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="javascript:void(0)" title="ÚNKP">ÚNKP-21</a>
            <ul>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_21_12'}">
                <a v-on:click="changePage('unkp_beszamolo_21_12')" href="javascript:void(0)">ÚNKP-21 12 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_21_10'}">
                <a v-on:click="changePage('unkp_beszamolo_21_10')" href="javascript:void(0)">ÚNKP-21 10 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_21_5'}">
                <a v-on:click="changePage('unkp_beszamolo_21_5')" href="javascript:void(0)">ÚNKP-21 5-6 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_tanulmanykotet_21'}">
                <a v-on:click="changePage('unkp_tanulmanykotet_21')" href="javascript:void(0)">ÚNKP-21 Tanulmánykötet</a>
              </li>
              <li :class="{active: this.$route.params.page == 'osztondijszerzodes_21'}">
                <a v-on:click="changePage('osztondijszerzodes_21')" href="javascript:void(0)">ÚNKP-21 Ösztöndíjszerződés</a>
              </li>
              <li>
                <a v-on:click="konzultaciosLap(21)" href="javascript:void(0)">Konzultációs lap letöltése</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_konferencia_21'}">
                <a v-on:click="changePage('unkp_konferencia_21')" href="javascript:void(0)">ÚNKP Konferencia</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="javascript:void(0)" title="ÚNKP">ÚNKP-22</a>
            <ul>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_22_12'}">
                <a v-on:click="changePage('unkp_beszamolo_22_12')" href="javascript:void(0)">ÚNKP-22 12 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_22_10'}">
                <a v-on:click="changePage('unkp_beszamolo_22_10')" href="javascript:void(0)">ÚNKP-22 10 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_22_5'}">
                <a v-on:click="changePage('unkp_beszamolo_22_5')" href="javascript:void(0)">ÚNKP-22 5 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_tanulmanykotet_22'}">
                <a v-on:click="changePage('unkp_tanulmanykotet_22')" href="javascript:void(0)">ÚNKP-22 Tanulmánykötet</a>
              </li>
              <li :class="{active: this.$route.params.page == 'osztondijszerzodes_22'}">
                <a v-on:click="changePage('osztondijszerzodes_22')" href="javascript:void(0)">ÚNKP-22 Ösztöndíjszerződés</a>
              </li>
              <li>
                <a v-on:click="konzultaciosLap(22)" href="javascript:void(0)">Konzultációs lap letöltése</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_konferencia_22'}">
                <a v-on:click="changePage('unkp_konferencia_22')" href="javascript:void(0)">ÚNKP Konferencia</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="javascript:void(0)" title="ÚNKP">ÚNKP-23</a>
            <ul>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_23_12'}">
                <a v-on:click="changePage('unkp_beszamolo_23_12')" href="javascript:void(0)">ÚNKP-23 12 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_23_10'}">
                <a v-on:click="changePage('unkp_beszamolo_23_10')" href="javascript:void(0)">ÚNKP-23 10 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_23_6'}">
                <a v-on:click="changePage('unkp_beszamolo_23_6')" href="javascript:void(0)">ÚNKP-23 6 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_beszamolo_23_5'}">
                <a v-on:click="changePage('unkp_beszamolo_23_5')" href="javascript:void(0)">ÚNKP-23 5 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'osztondijszerzodes_23'}">
                <a v-on:click="changePage('osztondijszerzodes_23')" href="javascript:void(0)">ÚNKP-23 Ösztöndíjszerződés</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_tanulmanykotet_23'}">
                <a v-on:click="changePage('unkp_tanulmanykotet_23')" href="javascript:void(0)">ÚNKP-23 Tanulmánykötet</a>
              </li>
              <li :class="{active: this.$route.params.page == 'unkp_konferencia_23'}">
                <a v-on:click="changePage('unkp_konferencia_23')" href="javascript:void(0)">ÚNKP Konferencia</a>
              </li>
            </ul>
          </li>
          -->
          <li>
            <a href="javascript:void(0)" title="EKÖP">EKÖP-24</a>
            <ul>
              <li :class="{active: this.$route.params.page == 'ekop_adategyeztetes'}">
                <a v-on:click="changePage('ekop_adategyeztetes')" href="javascript:void(0)">EKÖP-24 Adategyeztetés</a>
              </li>
              <li :class="{active: this.$route.params.page == 'ekop_beszamolo_24_10'}">
                <a v-on:click="changePage('ekop_beszamolo_24_10')" href="javascript:void(0)">EKÖP-24 10 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'ekop_beszamolo_24_5'}">
                <a v-on:click="changePage('ekop_beszamolo_24_5')" href="javascript:void(0)">EKÖP-24 5 havi Szakmai Záró Beszámoló</a>
              </li>
              <li :class="{active: this.$route.params.page == 'ekop_tanulmanykotet' && this.$route.query.y == '24'}">
                <a v-on:click="changePage('ekop_tanulmanykotet?y=24')" href="javascript:void(0)">EKÖP-24 Tanulmánykötet</a>
              </li>
              <li :class="{active: this.$route.params.page == 'ekop_konferencia' && this.$route.query.y == '24'}">
                <a v-on:click="changePage('ekop_konferencia?y=24')" href="javascript:void(0)">EKÖP-24 Konferencia</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="javascript:void(0)" title="EKÖP">EKÖP-KDP</a>
            <ul>
              <li :class="{active: this.$route.params.page == 'ekop_kdp_szakmai_beszamolo'}">
                <a v-on:click="changePage('ekop_kdp_szakmai_beszamolo')" href="javascript:void(0)">Szakmai beszámoló 2024/2025/1 félév</a>
              </li>
              <li :class="{active: this.$route.params.page == 'ekop_kdp_tanulmanykotet' && this.$route.query.y == '24'}">
                <a v-on:click="changePage('ekop_kdp_tanulmanykotet?y=24')" href="javascript:void(0)">EKÖP-KDP-24 Tanulmánykötet</a>
              </li>
              <li :class="{active: this.$route.params.page == 'ekop_kdp_konferencia' && this.$route.query.y == '24'}">
                <a v-on:click="changePage('ekop_kdp_konferencia?y=24')" href="javascript:void(0)">EKÖP-KDP-24 Konferencia</a>
              </li>
            </ul>
          </li>
          <li>
            <a v-on:click="changePage('sze_agazati_egyuttm_osztondij_szakmai_beszamolo')" href="javascript:void(0)" title="SZE Ágazati Együttműködési Ösztöndíj szakmai beszámoló">SZE Ágazati Együttműködési Ösztöndíj szakmai beszámoló</a>
          </li>

          <li :class="{active: this.$route.params.page == 'jegyzettamogatas'}">
            <a v-on:click="changePage('jegyzettamogatas')" href="javascript:void(0)" title="Jegyzettámogatás">Jegyzettámogatás</a>
          </li>

          <!--<li :class="{active: this.$route.params.page == 'tmdk_jel'}">
            <a v-on:click="changePage('tmdk_jel')" href="javascript:void(0)">TMDK jelentkezés</a>
          </li>-->
        </ul>
      </div>
    </div>

    <Scholarship v-if="this.$route.params.page=='osztondij'"></Scholarship>
    <Organization v-if="this.$route.params.page=='szerv_jel'"></Organization>
    <HATAR v-if="this.$route.params.page=='tamogatas'"></HATAR>
    <TMDK v-if="this.$route.params.page=='tmdk_jel'"></TMDK>
    <Osztondijszerzodes v-if="this.$route.params.page=='osztondijszerzodes'"></Osztondijszerzodes>
    <Osztondijszerzodes21 v-if="this.$route.params.page=='osztondijszerzodes_21'"></Osztondijszerzodes21>
    <Osztondijszerzodes22 v-if="this.$route.params.page=='osztondijszerzodes_22'"></Osztondijszerzodes22>
    <Osztondijszerzodes23 v-if="this.$route.params.page=='osztondijszerzodes_23'"></Osztondijszerzodes23>
    <UNKPTanulmanykotet19 v-if="this.$route.params.page=='unkp_tanulmanykotet_19'"></UNKPTanulmanykotet19>
    <UNKPTanulmanykotet20 v-if="this.$route.params.page=='unkp_tanulmanykotet_20'"></UNKPTanulmanykotet20>
    <UNKPTanulmanykotet21 v-if="this.$route.params.page=='unkp_tanulmanykotet_21'"></UNKPTanulmanykotet21>
    <UNKPTanulmanykotet22 v-if="this.$route.params.page=='unkp_tanulmanykotet_22'"></UNKPTanulmanykotet22>
    <UNKPTanulmanykotet23 v-if="this.$route.params.page=='unkp_tanulmanykotet_23'"></UNKPTanulmanykotet23>
    <UNKPBeszamolo v-if="this.$route.params.page=='unkp_beszamolo'"></UNKPBeszamolo>
    <UNKPBeszamolo10 v-if="this.$route.params.page=='unkp_beszamolo_10'"></UNKPBeszamolo10>
    <UNKPBeszamolo10Mod v-if="this.$route.params.page=='unkp_beszamolo_10_mod'"></UNKPBeszamolo10Mod>
    <UNKPBeszamolo205 v-if="this.$route.params.page=='unkp_beszamolo_20_5'"></UNKPBeszamolo205>
    <UNKPBeszamolo207 v-if="this.$route.params.page=='unkp_beszamolo_20_7'"></UNKPBeszamolo207>
    <UNKPBeszamolo2012 v-if="this.$route.params.page=='unkp_beszamolo_20_12'"></UNKPBeszamolo2012>
    <UNKPKonferencia v-if="this.$route.params.page=='unkp_konferencia'"></UNKPKonferencia>
    <UNKPKonferencia21 v-if="this.$route.params.page=='unkp_konferencia_21'"></UNKPKonferencia21>
    <UNKPKonferencia22 v-if="this.$route.params.page=='unkp_konferencia_22'"></UNKPKonferencia22>
    <UNKPKonferencia23 v-if="this.$route.params.page=='unkp_konferencia_23'"></UNKPKonferencia23>
    <UNKPBeszamolo215 v-if="this.$route.params.page=='unkp_beszamolo_21_5'"></UNKPBeszamolo215>
    <UNKPBeszamolo2110 v-if="this.$route.params.page=='unkp_beszamolo_21_10'"></UNKPBeszamolo2110>
    <UNKPBeszamolo2112 v-if="this.$route.params.page=='unkp_beszamolo_21_12'"></UNKPBeszamolo2112>
    <UNKPBeszamolo225 v-if="this.$route.params.page=='unkp_beszamolo_22_5'"></UNKPBeszamolo225>
    <UNKPBeszamolo2210 v-if="this.$route.params.page=='unkp_beszamolo_22_10'"></UNKPBeszamolo2210>
    <UNKPBeszamolo2212 v-if="this.$route.params.page=='unkp_beszamolo_22_12'"></UNKPBeszamolo2212>
    <UNKPBeszamolo235 v-if="this.$route.params.page=='unkp_beszamolo_23_5'"></UNKPBeszamolo235>
    <UNKPBeszamolo236 v-if="this.$route.params.page=='unkp_beszamolo_23_6'"></UNKPBeszamolo236>
    <UNKPBeszamolo2310 v-if="this.$route.params.page=='unkp_beszamolo_23_10'"></UNKPBeszamolo2310>
    <UNKPBeszamolo2312 v-if="this.$route.params.page=='unkp_beszamolo_23_12'"></UNKPBeszamolo2312>
    <EKOPBeszamolo245 v-if="this.$route.params.page=='ekop_beszamolo_24_5'"></EKOPBeszamolo245>
    <EKOPBeszamolo2410 v-if="this.$route.params.page=='ekop_beszamolo_24_10'"></EKOPBeszamolo2410>
    <RendszeresSzocialisOsztondij v-if="this.$route.params.page=='rendszeres_szocialis_osztondij'"></RendszeresSzocialisOsztondij>
    <EKOPAadategyeztetes v-if="this.$route.params.page=='ekop_adategyeztetes'"></EKOPAadategyeztetes>
    <EKOPKDPSzakmaiBeszamolo felev_kod="2024_25_1" v-if="this.$route.params.page=='ekop_kdp_szakmai_beszamolo'"></EKOPKDPSzakmaiBeszamolo>
    <SZEAgazatiEgyuttmOsztondijSzakmaiBeszamolo felev_kod="2024_25_1" v-if="this.$route.params.page=='sze_agazati_egyuttm_osztondij_szakmai_beszamolo'"></SZEAgazatiEgyuttmOsztondijSzakmaiBeszamolo>
    <Jegyzettamogatas v-if="this.$route.params.page=='jegyzettamogatas'"></Jegyzettamogatas>
    <EKOPTanulmanykotet v-if="this.$route.params.page=='ekop_tanulmanykotet'"></EKOPTanulmanykotet>
    <EKOPKonferencia v-if="this.$route.params.page=='ekop_konferencia'"></EKOPKonferencia>
    <EKOPKDPTanulmanykotet v-if="this.$route.params.page=='ekop_kdp_tanulmanykotet'"></EKOPKDPTanulmanykotet>
    <EKOPKDPKonferencia v-if="this.$route.params.page=='ekop_kdp_konferencia'"></EKOPKDPKonferencia>

    <div v-if="this.$route.params.page=='tamogatas'">
      <div class="szechenyi-wrapper container">
        <div class="col">
          <div class="szechenyi-logo-wrapper">
            <img class="logo" src="assets/img/szechenyi2020-compact.jpg">
          </div>
        </div>
        <div class="col">
          <div>
            <small><b>Pályázati azonosító:</b> EFOP-3.4.3-16-2016-00016</small>
          </div>
          <div>
            <small><b>Pályázat címe:</b> Intézményi fejlesztések a felsőfokú oktatás minőségének és hozzáférhetőségének együttes javítása érdekében a Széchenyi István Egyetemen</small>
          </div>
        </div>
      </div>
    </div>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>
<script>
import Vue from 'vue';
import HTMLHeader from './tpl_header.vue';
import HTMLFooter from './tpl_footer.vue';
import ProfileMenu from './tpl_profile_menu.vue';
import Scholarship from './competition/scholarship.vue';
import Organization from './competition/organization.vue';
import HATAR from './competition/hatar.vue';
import TMDK from './competition/tmdk.vue';
import Osztondijszerzodes from './competition/osztondijszerzodes.vue';
import Osztondijszerzodes21 from './competition/osztondijszerzodes_21.vue';
import Osztondijszerzodes22 from './competition/osztondijszerzodes_22.vue';
import Osztondijszerzodes23 from './competition/osztondijszerzodes_23.vue';
import UNKPTanulmanykotet19 from './competition/unkp_tanulmanykotet_19.vue';
import UNKPTanulmanykotet20 from './competition/unkp_tanulmanykotet_20.vue';
import UNKPTanulmanykotet21 from './competition/unkp_tanulmanykotet_21.vue';
import UNKPTanulmanykotet22 from './competition/unkp_tanulmanykotet_22.vue';
import UNKPTanulmanykotet23 from './competition/unkp_tanulmanykotet_23.vue';
import UNKPBeszamolo from './competition/unkp_beszamolo.vue';
import UNKPBeszamolo10 from './competition/unkp_beszamolo_10.vue';
import UNKPBeszamolo10Mod from './competition/unkp_beszamolo_10_mod.vue';
import UNKPBeszamolo205 from './competition/unkp_beszamolo_20_5.vue';
import UNKPBeszamolo207 from './competition/unkp_beszamolo_20_7.vue';
import UNKPBeszamolo2012 from './competition/unkp_beszamolo_20_12.vue';
import UNKPKonferencia from './competition/unkp_konferencia.vue';
import UNKPKonferencia21 from './competition/unkp_konferencia_21.vue';
import UNKPKonferencia22 from './competition/unkp_konferencia_22.vue';
import UNKPKonferencia23 from './competition/unkp_konferencia_23.vue';
import UNKPBeszamolo215 from './competition/unkp_beszamolo_21_5.vue';
import UNKPBeszamolo2110 from './competition/unkp_beszamolo_21_10.vue';
import UNKPBeszamolo2112 from './competition/unkp_beszamolo_21_12.vue';
import UNKPBeszamolo225 from './competition/unkp_beszamolo_22_5.vue';
import UNKPBeszamolo2210 from './competition/unkp_beszamolo_22_10.vue';
import UNKPBeszamolo2212 from './competition/unkp_beszamolo_22_12.vue';
import UNKPBeszamolo235 from './competition/unkp_beszamolo_23_5.vue';
import UNKPBeszamolo236 from './competition/unkp_beszamolo_23_6.vue';
import UNKPBeszamolo2310 from './competition/unkp_beszamolo_23_10.vue';
import UNKPBeszamolo2312 from './competition/unkp_beszamolo_23_12.vue';
import EKOPBeszamolo245 from './competition/ekop_beszamolo_24_5.vue';
import EKOPBeszamolo2410 from './competition/ekop_beszamolo_24_10.vue';
import RendszeresSzocialisOsztondij from './competition/rendszeres_szocialis_osztondij.vue';
import EKOPAadategyeztetes from './competition/ekop_adategyeztetes.vue';
import EKOPKDPSzakmaiBeszamolo from './competition/ekop_kdp_szakmai_beszamolo.vue';
import SZEAgazatiEgyuttmOsztondijSzakmaiBeszamolo from './competition/sze_agazati_egyuttm_osztondij_szakmai_beszamolo.vue';
import Jegyzettamogatas from './competition/jegyzettamogatas.vue';
import EKOPTanulmanykotet from './competition/ekop_tanulmanykotet.vue';
import EKOPKonferencia from './competition/ekop_konferencia.vue';
import EKOPKDPTanulmanykotet from './competition/ekop_kdp_tanulmanykotet.vue';
import EKOPKDPKonferencia from './competition/ekop_kdp_konferencia.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu,
    Scholarship,
    Organization,
    HATAR,
    TMDK,
    Osztondijszerzodes,
    UNKPTanulmanykotet19,
    UNKPTanulmanykotet20,
    UNKPTanulmanykotet21,
    UNKPTanulmanykotet22,
    UNKPTanulmanykotet23,
    UNKPBeszamolo,
    UNKPBeszamolo10,
    UNKPBeszamolo10Mod,
    UNKPBeszamolo205,
    UNKPBeszamolo207,
    UNKPBeszamolo2012,
    UNKPKonferencia,
    UNKPKonferencia21,
    UNKPKonferencia22,
    UNKPKonferencia23,
    Osztondijszerzodes21,
    Osztondijszerzodes22,
    Osztondijszerzodes23,
    UNKPBeszamolo215,
    UNKPBeszamolo2110,
    UNKPBeszamolo2112,
    UNKPBeszamolo225,
    UNKPBeszamolo2210,
    UNKPBeszamolo2212,
    UNKPBeszamolo235,
    UNKPBeszamolo236,
    UNKPBeszamolo2310,
    UNKPBeszamolo2312,
    EKOPBeszamolo245,
    EKOPBeszamolo2410,
    RendszeresSzocialisOsztondij,
    EKOPAadategyeztetes,
    EKOPKDPSzakmaiBeszamolo,
    SZEAgazatiEgyuttmOsztondijSzakmaiBeszamolo,
    Jegyzettamogatas,
    EKOPTanulmanykotet,
    EKOPKonferencia,
    EKOPKDPTanulmanykotet,
    EKOPKDPKonferencia
  },
  data: function() {
    return {
      page: 'osztondij'
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.page === 'tamogatas') {
        return {
          main: 'HATÁR',
          sub: 'Hallgatói Támogatások Rendszere'
        }
      } else if (this.$route.params.page === 'osztondij') {
        return {
          main: 'ÖSZTÖNDÍJAK',
          sub: 'Ösztöndíj pályázat benyújtása'
        }
      } else if (this.$route.params.page === 'szerv_jel') {
        return {
          main: 'SZERVEZETI JELENTKEZÉS',
          sub: 'Jelentkezés szervezetbe'
        }
      }
      return {
        main: 'PÁLYÁZATOK',
        sub: 'Jelentkezés pályázatra'
      }
    }
  },
  mounted: function() {
    if (this.$route.params.page != 'osztondij') {
      if (this.$root.user == '') {
        this.$root.openLoginPopup();
      }
    }
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      if (this.$route.params.page != 'osztondij') {
        if (this.$root.user == '') {
          this.$root.openLoginPopup();
        }
      }
    }
  },
  methods: {
    konzultaciosLap: function(azonosito) {
      const _this = this;

      this.$root.ajax('form/unkp_konzultacios_lap', {
        method: 'POST',
        data: {
          azonosito: azonosito
        },
        success: function(response) {
          if (response.error) {
            swal('Hiba!', response.error, 'error');
          } else {
            if (response.filename != undefined)
              window.open('assets/konzultacios_lapok/' + response.filename);
          }
        }
      });
    },

    changePage: function(page) {
      this.$router.push({path: '/palyazatok/' +  page});
    }
  }
}

</script>



// WEBPACK FOOTER //
// competition.vue?57c7e7ee